import React, { useEffect, useContext, useState } from 'react'

import { FilterBy } from './Orders/index.jsx';
import { useOrdersTabs } from './Orders/ordersTabs';
import { PageHeader, PageLayout } from '../components/layout';
import { OrdersList } from "../components/order";
import { UserContext } from '../contexts/index.jsx';
import "./Orders/orders-dark.scss";
import { HOME_PATH } from "../core/config/dashboard.js";

const options = [
  { id: null, name: 'All Statuses' },
  { id: 'created', name: 'Created' },
  { id: 'paid', name: 'Completed' },
  { id: 'cancelled', name: 'Canceled' },
  { id: 'refunded', name: 'Refunded' },
];

const Orders = ({ user }) => {
  const { notifications, seeNotification } = useContext(UserContext);
  const [filterBy, setFilterBy] = useState('');
  const tabs = useOrdersTabs();

  useEffect(() => {
      seeNotification('orders');
  }, [notifications]);

  // Same shell as Manage Listings: one `.rc-page`, the chrome and the body inside
  // it, the gutter declared once by the shell. The Bootstrap `.container` that
  // used to wrap the body is gone — it was a capped, centred column, so the cards
  // never lined up with the title above them.
  //
  // `orders-dark` stays on `<main id="pages">`: ten selectors in orders-dark.scss
  // need the id and the class on the same element.
  return (
    <PageLayout className="orders-page">
      <PageHeader
        title="Cart Orders"
        description="Checkout orders placed through the store, with payment status."
        backTo={HOME_PATH}
        tabs={tabs}
      />
      <main id="pages" className={`flex-grow-1 mb-5 orders-dark`}>
        <div className="filter-by-container">
          <FilterBy
            {...{
              placeholder: 'Filter by Status',
              filterBy,
              setFilterBy,
              options,
            }}
          />
        </div>

        <section className="orders mt-3">
          <OrdersList user={user} params={{ filters: { status: filterBy } }} />
        </section>
      </main>
    </PageLayout>
  );
}

export default Orders
